<app-section
  titleSection="Les plus"
  [isActivated]="perks.isEnabled"
  (enabled)="onEnabled($event)"
  (cancled)="onCancled()"
>
  <div read-mode class="px-3">
    <app-les-plus-read-mode [perks]="perks"> </app-les-plus-read-mode>
  </div>

  <div edit-mode>
    <app-les-plus-edit-mode
      [perks]="perks"
      (perksChanged)="onPerksChanged($event)"
    >
    </app-les-plus-edit-mode>
  </div>

  <div save-button>
    <p-button
      id="btn-valider-section"
      label="Valider"
      level="primary"
      title="Valider"
      [loading]="isLoading"
      [disabled]="isLoading"
      (click)="onSaveSection()"
    ></p-button>
  </div>
</app-section>
